/** @prettier */

import {
  FormControlLabel,
  FormGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Checkbox,
} from '@mui/material';
import React, {useState} from 'react';
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

//MTH component import
import APIErrorMessage from '../../component/APIErrorMessage';
//API import
import {
  deleteCompositionsSLUnit,
  getCompositionsSLUnit,
} from '../../API/API_Collection';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {slInfoSort} from '../../functions/sort';
import {PrimaryButton, SecondaryButton} from '../../component/BasicButton';

/**
 * 室外機削除ダイアログ
 * @param props props
 * @returns JSX.Element
 */
const OUDeleteDialog = (props: {
  /** 削除する室外機ID */
  ouID: string;
  /** 削除する室外機の名前 */
  ouName: string;
  /** 室内外機の情報（set関数） */
  setSLInfo: React.Dispatch<
    React.SetStateAction<apiIF.res.getCompositionsSLUnit | null>
  >;
  /** ダイアログを開くかどうか */
  isOpenDialog: boolean;
  /** ダイアログを開くかどうか（set関数） */
  setIsOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  /** 課金しているかどうか */
  isBilling: boolean;
  /** GW毎の構成情報未反映の有無（set関数） */
  setHasConfigGW: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  //パスパラメータ取得
  const {siteID, gwID} = useParams();

  const [checked1, setChecked1] = useState(false); //1行目のチェックボックス
  const [checked2, setChecked2] = useState(false); //2行目のチェックボックス
  const [okBtnDisabled, setOKBtnDisabled] = useState(true); //OKボタン非表示フラグ
  const [isOpenErrorDialog, setIsOpenErrorDialog] = useState(false); //APIエラー時のエラーダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  const trans = useTranslation().t; //翻訳関数

  /**
   * OKボタン押下時処理
   */
  const ouDelete = () => {
    //パスパラメータを取得できない場合
    if (siteID === undefined || gwID === undefined) {
      return;
    }

    setOKBtnDisabled(true);
    setAPIWait(true);

    //室外機の削除
    deleteCompositionsSLUnit(siteID, gwID, props.ouID)
      .then(() => {
        //室内外機の情報を取得
        return getCompositionsSLUnit(siteID, gwID, {'max-result': 400});
      })
      .then(response => {
        response = slInfoSort(response);
        props.setSLInfo(response);
        props.setHasConfigGW(props.isBilling); //課金している場合のみ表示
        handleClose();
      })
      .catch(() => {
        setIsOpenErrorDialog(true);
      })
      .finally(() => {
        setAPIWait(false);
      });
  };
  /**
   * CANCELボタン押下時処理
   */
  const handleClose = () => {
    props.setIsOpenDialog(false);
    setChecked1(false);
    setChecked2(false);
  };

  /**
   * チェックボックス押下時処理
   * @param event
   * @param check 押下したチェックボックスの名前
   */
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    check: string
  ) => {
    if (check === 'check1') {
      setChecked1(event.target.checked);
      if (event.target.checked === false || checked2 === false) {
        setOKBtnDisabled(true);
      } else {
        setOKBtnDisabled(false);
      }
    }
    if (check === 'check2') {
      setChecked2(event.target.checked);
      if (event.target.checked === false || checked1 === false) {
        setOKBtnDisabled(true);
      } else {
        setOKBtnDisabled(false);
      }
    }
  };

  return (
    <>
      <Dialog
        open={props.isOpenDialog}
        onClose={handleClose}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          {trans('OUDeleteDialog.superlinkUnit.title')}
        </DialogTitle>
        <DialogContent>
          {/* 室外機名称の表示 */}
          <DialogContentText>
            {trans('OUDeleteDialog.superlinkUnit.msg')} {props.ouName}
          </DialogContentText>
          {/* チェックボックス */}
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={e => handleChange(e, 'check1')}
                  id={`mv-Check1DeleteOu${props.ouName}`}
                />
              }
              checked={checked1}
              label={trans('OUDeleteDialog.checkboxDescription.unrestorable')}
            />
          </FormGroup>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={e => handleChange(e, 'check2')}
                  id={`mv-Check2DeleteOu${props.ouName}`}
                />
              }
              checked={checked2}
              label={trans(
                'OUDeleteDialog.checkboxDescription.operationDataDeleted'
              )}
            />
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            disabled={apiWait}
            onClick={handleClose}
            buttonText={trans('OUDeleteDialog.buttonTxt.cancel')}
            id={`mv-btnCancelDeleteOu${props.ouName}`}
          />
          <PrimaryButton
            onClick={ouDelete}
            buttonText={trans('OUDeleteDialog.buttonTxt.ok')}
            id={`mv-btnOkDeleteOu${props.ouName}`}
            disabled={okBtnDisabled}
            apiWait={apiWait}
          />
        </DialogActions>
      </Dialog>
      <APIErrorMessage
        open={isOpenErrorDialog}
        setOpen={setIsOpenErrorDialog}
        id={`${props.ouName}DeleteErrDlgBtn`}
      />
    </>
  );
};
export default OUDeleteDialog;
